import axios from 'axios'

//axios.defaults.baseURL = 'http://192.168.0.38:8080/'
//axios.defaults.baseURL = 'http://10.42.0.1:8080/'

axios.defaults.baseURL = '/'
axios.defaults.headers.common['Authorization'] =
  'Bearer ' + localStorage.getItem('token')
